import { isDefined } from './Common';

const userKey = "userData_pedidos";
const origemKey = "origemData_pedidos";
const empresaKey = "empresaData_pedidos";

const getLocalStorage = () => {
    return localStorageSupported() ? window.localStorage : window.fakeStorage;
}

const localStorageSupported = () => {
    let testKey = "test";
    let storage = window.localStorage;

    try {
        storage.setItem(testKey, "1");
        storage.removeItem(testKey);
        return true;
    } catch (error) {
        if (!isDefined(window.fakeStorage)) {
            initializeFakeStorage();
        }
        return false;
    }
}

// ##################### DEVELOPMENT ONLY #####################

// eslint-disable-next-line
const exampleEmpresa = { 
    idtCliente: 1, 
    origem: 1,
    nome: 'Pedreira Lerroville', 
    corTema: 'yellow', 
    corBackground: '#828282',
    logo: 'https://sc.mysaas.com.br/logos/logo_erp_lerroville_1.png'
} 

// eslint-disable-next-line
const exampleUser = { 
    idt: 8, 
    nome: 'COMERCIO DE MATERIAIS PARA CONSTRUCAO LIDIANOPOLIS LTDA - EPP', 
    documento: '79.209.482/0001-44', 
    isCliente: false,
    empresas: [
        {
            idt: 1,
            nome: 'Pedra Bruta'
        },
        {
            idt: 4,
            nome: 'Pedra Polida - Materiais de Construção'
        }
    ]
}

// ############################################################

/**
 * Atributos do objeto de usuário:
 * {
 *      "idt": 10,
 *      "nome": "Joaozinho da Silva",
 *      "documento": "15.610.121/0001-22",
 *      "isCliente": true 
 * }
 */
export const getLoggedUser = () => {
    const json = getLocalStorage().getItem(userKey);
    return isDefined(json) ? JSON.parse(json) : null;
}

export const setLoggedUser = (user) => {
    /* Verifica se o objeto de usuário que está sendo setado é valido */
    if(isDefined(user) && !isDefined(user.documento)){
        user = undefined;
    }
    
    if(isDefined(user) && user.isCliente){
        setOrigem({
            idt: getEmpresa().origem,
            nome: getEmpresa().razaoSocial
        });
    }
    
    getLocalStorage().setItem(userKey, JSON.stringify(user));
}

/**
 * Atributos do objeto de empresa:
 * {
 *      "idtCliente": 1,
 *      "razaoSocial": "Postos Pelanda",
 *      "corTema": "teal",
 *      "corBackground": "#2C7797",
 *      "logo": "data:image/jpeg;base64, LzlqLzRBQ..."
 * }
 */
export const getEmpresa = () => {
    const json = getLocalStorage().getItem(empresaKey);
    return isDefined(json) ? JSON.parse(json) : null;
}

export const setEmpresa = (empresa) => {
    /* Verifica se o objeto de empresa que está sendo setado é valido */
    if(isDefined(empresa) && 
        (!isDefined(empresa.idtCliente) ||
            !isDefined(empresa.razaoSocial) ||
                !isDefined(empresa.corTema) ||
                    !isDefined(empresa.corBackground) ||
                        !isDefined(empresa.logo))){
                            empresa = undefined;
    }
    
    clearUserState();
    getLocalStorage().setItem(empresaKey, JSON.stringify(empresa));
}

/**
 * Atributos do objeto de origem:
 * {
 *      "idt": 1,
 *      "nome": "Pedra Bruta"
 * }
 */
export const getOrigem = () => {
    const json = getLocalStorage().getItem(origemKey);
    return isDefined(json) ? JSON.parse(json) : null;
}

export const setOrigem = (origem) => {
    getLocalStorage().setItem(origemKey, JSON.stringify(origem));
}

export const isEmpresaSet = () => {
    return isDefined(getEmpresa());
}

export const isLoggedIn = () => {
    return getLoggedUser() !== null;
}

export const clearUserState = () => {
    getLocalStorage().removeItem(userKey);
    getLocalStorage().removeItem(origemKey);
}

export const clearEmpresaState = () => {
    getLocalStorage().removeItem(empresaKey);
    getLocalStorage().removeItem(origemKey);
}

const initializeFakeStorage = () => {
    window.fakeStorage = {
        _data: {},

        setItem: function (id, val) {
            return this._data[id] = String(val);
        },

        getItem: function (id) {
            return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
        },

        removeItem: function (id) {
            return delete this._data[id];
        },

        clear: function () {
            return this._data = {};
        }
    }
}


// WEBPACK FOOTER //
// ./src/util/StorageManager.js